<template>
  <div class="graphics-modern">
    <NavBar />
    <AuthBySessionExpired />

    <div class="graphics-container">
      <!-- Header Section -->
      <div class="graphics-header">
        <div class="header-content">
          <h1 class="page-title">
            <i class="fas fa-chart-bar title-icon"></i>
            Gráficos Administrativos
          </h1>
          <p class="page-subtitle">
            Visualização de dados e estatísticas da instituição
          </p>
        </div>
      </div>

      <!-- Content Section -->
      <div class="graphics-content">
        <!-- Main Chart - Full Width -->
        <div class="chart-section main-chart">
          <MostUsedMedicines />
        </div>

        <!-- Secondary Charts Grid -->
        <div class="charts-grid">
          <div class="chart-item">
            <UsedAndUnusedBeds />
          </div>
          <div class="chart-item">
            <Genders />
          </div>
          <div class="chart-item">
            <DegreeOfDependence />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { userData } from "../lib/functions";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import NavBar from "../templates/NavBar";
import MostUsedMedicines from "../templates/Graphics/MostUsedMedicines";
import UsedAndUnusedBeds from "../templates/Graphics/UsedAndUnusedBeds";
import Genders from "../templates/Graphics/Genders";
import DegreeOfDependence from "../templates/Graphics/DegreeOfDependence";

export default {
  name: "Graphics",
  components: {
    NavBar,
    AuthBySessionExpired,
    MostUsedMedicines,
    UsedAndUnusedBeds,
    Genders,
    DegreeOfDependence,
  },
  data() {
    return {
      permissions: {},
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    async retrieve() {
      this.permissions = userData().permissions;
    },
  },
};
</script>

<style scoped>
.graphics-modern {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.graphics-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Header Section */
.graphics-header {
  padding: 24px 0;
  background: white;
  border-radius: 0 0 24px 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 32px;
}

.header-content {
  text-align: center;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

.page-title {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.title-icon {
  color: #0f65b0;
  margin-right: 12px;
}

.page-subtitle {
  color: #64748b;
  margin: 8px 0 0 0;
  font-size: 16px;
}

/* Content Layout */
.graphics-content {
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-bottom: 32px;
}

/* Main Chart Section */
.chart-section.main-chart {
  width: 100%;
}

/* Charts Grid */
.charts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 24px;
}

.chart-item {
  height: fit-content;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .charts-grid {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 20px;
  }
}

@media (max-width: 768px) {
  .graphics-container {
    padding: 0 16px;
  }

  .graphics-header {
    padding: 20px 0;
    margin-bottom: 24px;
  }

  .header-content {
    padding: 0 16px;
  }

  .page-title {
    font-size: 24px;
    flex-direction: column;
    gap: 8px;
  }

  .page-subtitle {
    font-size: 14px;
  }

  .graphics-content {
    gap: 20px;
  }

  .charts-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 20px;
  }

  .title-icon {
    font-size: 20px;
  }
}
</style>